import { format } from "date-fns";

export const upperCase = (text) => {
  if (!text) return ""; 
  let str = text.split(/[\s_-]+/);
  if (str[str.length-1] === 'template') str.pop();
  return str.map(s => s.toUpperCase() === 'AI' ? 'AI' : s.charAt(0).toUpperCase() + s.slice(1)).join(" ")
};

export const capitalizeWords = (str) => {
  if (!str) return "";
  return str.trim().split(/[\s_]+/).map((word) =>
    word ? word[0].toUpperCase() + word.substring(1) : ''
  ).join(' ');
};

export const safePathSegment = (name) =>
  String(name || "upload").replaceAll("/", "_").replaceAll("\\", "_");

export const formatTimestamp = (date, type = "default") => {
  if (!date) {
    return "";
  }
  const timestamp = new Date(date);
  switch (type) {
    case "m/d/y/h":
      return format(timestamp, "MMM d yyyy, HH:mm");

    case "d/m/y/h":
      return format(timestamp, "d MMM yyyy, HH:mm");

    case "d/m/y":
      return format(timestamp, "d MMM yyyy");

    case "d.m.y":
      return format(timestamp, "dd.MM.yyyy");

    default:
      return format(timestamp, "MMM d, HH:mm");
  }
};
